package app.bloomey.web.components.widgets

import androidx.compose.runtime.Composable
import app.bloomey.web.components.sections.ColorModeButton
import app.bloomey.web.core.data.Envars
import app.bloomey.web.theme.SitePalette
import app.bloomey.web.theme.toSitePalette
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px

@Composable
fun EnvironmentTag() {
    val sitePalette: SitePalette = ColorMode.current.toSitePalette()
    Row(
        modifier = Modifier
            .padding(leftRight = 8.px, topBottom = 4.px)
            .position(Position.Fixed)
            .zIndex(3)
            .right(0.px)
            .bottom(0.px)
            .background(sitePalette.nearBackground),
        verticalAlignment = Alignment.CenterVertically
    ) {
        SpanText(Envars.environment.name, modifier = Modifier.margin(right = 6.px))
        ColorModeButton()
    }
}